<ng-template #header>
	<h3>
		-
		{{
			(showByCreatedAt == "yes" ? "show_by_created_at" : "show_by_expense_date")
				| langVal
		}}
	</h3>
</ng-template>

<div class="d-flex">
	<div class="colstat colstat-small">
		<app-gen-select
			[options]="years"
			[actualObj]="this"
			fieldName="year"
			(changeEvent)="loadData()"
		/>
	</div>
	<div>
		<app-gen-button-group
			[actualObj]="this"
			fieldName="year"
			[options]="periodInputs"
			title_ph_lang="period"
			(changeEvent)="changeByPeriod($event)"
		/>
	</div>
	@if (is_new_vat_number) {
		<div class="col-4 col-md-2">
			<app-gen-select
				[actualObj]="this"
				fieldName="vat_number"
				[options]="vat_numbers"
				(changeEvent)="loadData()"
			/>
		</div>
	}
</div>
<div class="row">
	<label>{{ "show_expenses" | langVal }}</label>
	<div class="col-12">
		<app-gen-button-group
			[actualObj]="this"
			fieldName="showByCreatedAt"
			optionsListName="showByCreatedAt_opts"
			title_ph_lang="show_by_created_at"
			(changeEvent)="changeBtn('showByCreatedAt', showByCreatedAt)"
		/>
	</div>
</div>
<div class="row profitloss">
	<div class="col-12">
		@if (data) {
			<div id="section-to-print">
				<div>{{ "year" | langVal }}: {{ year }}</div>
				<div class="table-responsive">
					<table class="table table-hover table-striped table-rows pad-block">
						<thead>
							<tr>
								<th>{{ "income" | langVal }}</th>
								@for (monthRow of data; track monthRow) {
									<th>{{ monthNames[$index] | langVal }}</th>
								}
								<th>{{ "total" | langVal }}</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>{{ "income" | langVal }}</td>
								@for (monthRow of data; track monthRow) {
									<td>{{ data[$index].income }}</td>
								}
								<td>{{ totals.income }}</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="table-responsive">
					<table class="table table-hover table-striped table-rows pad-block">
						<thead>
							<tr>
								<th>
									{{ "expenses" | langVal }} -{{
										(showByCreatedAt == "yes"
											? "by_created_at"
											: "by_expense_date"
										) | langVal
									}}
								</th>
								@for (monthRow of data; track monthRow) {
									<th>{{ monthNames[$index] | langVal }}</th>
								}

								<th>{{ "total" | langVal }}</th>
							</tr>
						</thead>
						<tbody>
							@for (
								expensetypeName of expensetypeNames;
								track expensetypeName
							) {
								<tr>
									<td>{{ expensetypeName }}</td>
									@for (monthRow of data; track monthRow) {
										<td>{{ data[$index][expensetypeName] || 0 }}</td>
									}
									<td>{{ totals[expensetypeName] || 0 }}</td>
								</tr>
							}
							<tr>
								<td>{{ "total" | langVal }}</td>
								@for (monthRow of data; track monthRow) {
									<td>{{ data[$index].totalExpenses || 0 }}</td>
								}
								<td>{{ totals.totalExpenses }}</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="table-responsive">
					<table class="table table-hover table-striped table-rows pad-block">
						<thead>
							<tr>
								<th>{{ "profitloss" | langVal }}</th>
								@for (monthRow of data; track monthRow) {
									<th>{{ monthNames[$index] | langVal }}</th>
								}

								<th>{{ "total" | langVal }}</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>{{ "profitloss" | langVal }}</td>
								@for (monthRow of data; track monthRow) {
									<td>{{ data[$index].profitloss }}</td>
								}
								<td>{{ totals.profitloss }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		}
	</div>
</div>

<div class="modal-btns">
	@if (isModalMode) {
		<app-cancel-btn (click)="close()" />
	}
	<button
		tabindex="1"
		class="btn btn-primary"
		(click)="print()"
	>
		{{ "print" | langVal }}
	</button>
	<button
		tabindex="-1"
		class="btn btn-primary"
		(click)="downloadReport()"
	>
		{{ "create_excel" | langVal }}
	</button>
</div>
